import { Button } from '@chakra-ui/react';
import React from 'react';

export const SettingsEditButton = ({
  label,
  icon,
  onClickHandler,
}: {
  label: React.ReactNode;
  icon: React.ReactElement;
  onClickHandler: any;
}) => {
  return (
    <Button
      height="45px"
      width="115px"
      border="1px"
      borderColor="#DBD3CA"
      bg="white"
      padding="16px 24px"
      fontSize="16px"
      fontWeight="light"
      borderRadius="0"
      rightIcon={icon}
      iconSpacing="8px"
      _hover={{ bg: '#f9f6f1' }}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
};
